module.exports = require('./helpers/bundle-url').getBundleURL('1fz0F') + "logo.7718c6df.svg";